import { twMerge } from '@/lib/classname/twMerge'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import type { ComponentProps } from 'react'
import { textInputSizes } from './TextInput.client'

type TextInputSkeletonProps = ComponentProps<typeof BaseSkeleton> & {
  size?: keyof typeof textInputSizes
}

export function TextInputSkeleton({ size = 'md', className, ...rest }: TextInputSkeletonProps) {
  const sizeClasses = textInputSizes[size].replace(/\[&_input\]:/g, '')

  return <BaseSkeleton className={twMerge('w-full', sizeClasses, className)} {...rest} />
}
